import React from 'react';
import DataTable from '../DataTable';
import isoDateConverter from '../isoDateConverter';
import { ExternalLinkAlt } from '@styled-icons/fa-solid';

const OrderFormUploadTable = ({
  dth,
  data,
  updateData,
  setPaginationLoaded,
  persist,
  setPersist,
  handleClose,
  handleButtonClick,
}) => {
  return (
    <div className="px-3 pt-4">
      <DataTable
        handle={dth}
        lazyLoading
        filterable
        sortable
        data={data}
        className="table-striped fixed-table-size"
        advancedSearch
        showAdvnSearch={true}
        onUpdate={updateData}
        onPaginationLoaded={() => {
          setPaginationLoaded(true);
        }}
        persistGetter={persist}
        persistSetter={setPersist}
      >
        <DataTable.Head>
          <section className="d-flex justify-content-end datatable-button">
            <button
              type="button"
              className="stepper-button yellow"
              onClick={() => {
                handleClose();
              }}
            >
              Close
            </button>
          </section>
        </DataTable.Head>
        <DataTable.Pagination itemsPerPage={[10, 15, 50]} areaPadding={'0px'} />
        <DataTable.Column
          colKey="uploadedDate"
          header="Date and Time"
          searchOpts={{ type: 'text', sendAs: 'dateTime' }}
          fixedWidth="25%"
        >
          {(item) => {
            return isoDateConverter(item.uploadedDate);
          }}
        </DataTable.Column>
        <DataTable.Column
          colKey="uploadedBy"
          header="Uploaded By"
          searchOpts={{ type: 'text', sendAs: 'uploadedBy' }}
          fixedWidth="25%"
        />
        <DataTable.Column
          colKey="fileTitle"
          header="File Uploaded"
          searchOpts={{ type: 'text', sendAs: 'fileTitle' }}
          fixedWidth="40%"
        />
        <DataTable.Column
          header="Download"
          style={{ height: '1px', padding: 0 }}
          headerStyle={{ textAlign: 'center' }}
          fixedWidth="10%"
        >
          {(item) => (
            <button
              className="external-table-link"
              onClick={() => {
                handleButtonClick(item.blobTitle);
              }}
            >
              <ExternalLinkAlt width="1.1rem" height="1.1rem" color="#00857d" />
            </button>
          )}
        </DataTable.Column>
      </DataTable>
    </div>
  );
};

export default OrderFormUploadTable;
